import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["circle",{"cx":"12","cy":"12","r":".5","fill":"currentColor","key":"svg-0"}],["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-1"}]]

const IconFocus = createReactComponent('outline', 'focus', 'Focus', __iconNode);

export default IconFocus;